import { styled } from "@mui/material/styles";

const PageLoaderWrapper = styled("div")({
  display: "flex", 
  alignItems: "center", 
  justifyContent: "center", 
  height: "100vh"
});

export default PageLoaderWrapper;